import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Body, FlexWrapper } from 'components/Shell/Shell'
import { Redirect } from 'react-router-dom'
import { GET_ALL_WIZARDS, GET_APP_SETTING_BY_NAME } from '../../requests'
import { Spinner } from 'components/Loaders/Loaders'
import DocumentIcon from '@tecuity/sos-icons/react/document'
// import CircularActionBlock from 'components/CircularActionBlock/CircularActionBlock';
import DocumentAddIcon from '@tecuity/sos-icons/react/document-add'
import Transition from 'react-prop-transition'
import onClickOutside from 'react-onclickoutside'
import ImportIcon from '@tecuity/sos-icons/react/import'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import { readFileAsText } from 'utilities'
import {
  fetchAndPopulateWizard,
  reconstructWizardWithValues,
  resetWizardState,
} from '../Wizard2/WizardActions'
import ICONS from 'components/Icons/Icons'
import { history } from '../../store'
import { SUBROUTES_OBJ } from '../../App'
import { getUniqueJSONvalues } from 'utilities'
import shortid from 'shortid'
import { setActiveCategory } from './FormsActions'
import './Forms.scss'
import FocusTrap from 'focus-trap-react'

class Forms extends Component {
  constructor() {
    super()
    this.state = {
      wizards: null,
      categories: null,
      categoriesOrder: null,
      categoryIcons: null,
      loading: true,
      wizardsLoaded: {},
      filter: '',
    }
  }
  componentDidMount = () => {
    if (this.props.match.params.category) {
      if (!SUBROUTES_OBJ[this.props.match.params.category]) {
        this.props.history.replace('/404')
      } 
      this.getForms(this.props.match.params.category)
    }
  }
  componentDidUpdate = (prevProps) => {
    let prevCategory = prevProps.match.params.category
    let currentCategory = this.props.match.params.category
    let categoryHasSwitched = prevCategory !== currentCategory && currentCategory
    if (categoryHasSwitched) {
      if (!SUBROUTES_OBJ[currentCategory]) {
        this.props.history.replace('/404')
      } else if (!this.state.wizardsLoaded[currentCategory]) {
        this.props.setActiveCategory(currentCategory)
        this.setState({ loading: true })
        this.getForms(currentCategory)
      }
    }
  }
  getForms = (category = this.props.subLinks[0].parameter) => {
    let promises = []
    promises[0] = new Promise((resolve) => {
      GET_ALL_WIZARDS(category, (data) => {
        resolve(data)
      })
    })
    promises[1] = new Promise((resolve) => {
      GET_APP_SETTING_BY_NAME('FORM_MANAGER_STRUCTURE', (data) => {
        resolve(JSON.parse(data.VALUE))
      })
    })
    Promise.all(promises).then((responses) => {
      let wizards = {}
      responses[0].forEach((wizard) => {
        wizards[wizard.FORM_DEFINITION_ID] = wizard
      })
      this.setState((state) => ({
        wizards: { ...state.wizards, ...wizards },
        wizardsLoaded: { ...state.wizardsLoaded, [category]: true },
        categories: responses[1].categories,
        categoriesOrder: responses[1].categoriesOrder,
        categoryIcons: responses[1].categoryIcons,
        loading: false,
      }))
    })
  }
  loadForm = (formDefinitionId) => {
    this.props.history.push('/forms/new/' + formDefinitionId)
  }
  setFilter = (e) => {
    this.setState({
      filter: e.target.value,
    })
  }
  render() {
    const { loading, categories, categoriesOrder, categoryIcons = {}, wizards } = this.state
    const { siteOffline, match, activeCategory, sublinks } = this.props
    const sanitizedCategory = match.params.category ? match.params.category : 'business'
    const activeCategories = loading ? {} : categories[sanitizedCategory]
    const activeCategoriesOrder = loading ? [] : categoriesOrder[sanitizedCategory] || []
    const activeCategoryIcon = loading ? '' : categoryIcons[sanitizedCategory]
    const sublinkExists = sublinks.find((x) => x.parameter === match.params.category) ? true : false
    return (
      <Body className="forms">
        <h1 className="page-title">Forms</h1>
        {siteOffline && <Redirect to="/" />}
        <Toolbar filter={this.state.filter} onChange={this.setFilter} />
        {!this.props.match.params.category || !sublinkExists ? (
          <Redirect to={`/forms/${activeCategory || this.props.sublinks[0].parameter}`} />
        ) : (
            <FlexWrapper direction="column" aria-busy={loading}>
              {loading ? (
                <div className="loading-wrapper forms-wrapper">
                  <Spinner className="page-loader" themeColor="neutral" />
                </div>
              ) : (
                  activeCategoriesOrder.map((categoryId) =>
                    activeCategories[categoryId].wizardsOrder.length > 0 &&
                      activeCategories[categoryId].visible === true ? (
                        <DumbCategory
                          {...activeCategories[categoryId]}
                          icon={activeCategoryIcon}
                          filter={this.state.filter}
                          key={categoryId}
                          wizards={wizards}
                          loadForm={this.loadForm}
                        />
                      ) : null
                  )
                )}
            </FlexWrapper>
          )}
      </Body>
    )
  }
}
export default connect(
  (state) => ({
    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
    activeCategory: state.forms.activeCategory || state.app.currentCategory,
  }),
  { setActiveCategory }
)(Forms)

class Toolbar extends Component {
  startImportWizard = (e) => {
    readFileAsText(e).then((json) => {
      json = getUniqueJSONvalues(json)
      this.props.resetWizardState()
      this.props.fetchAndPopulateWizard(json.ORIGIN_FDID, () => {
        this.props.reconstructWizardWithValues(json.FIELD_VALUES)
        history.push(`new/${json.ORIGIN_FDID}?prefilled=true`)
      })
    })
  }
  clearFilter = () => {
    this.props.onChange({ target: { value: '' } })
  }
  render() {
    const { filter, onChange, isAdmin, loggedIn } = this.props
    return (
      <div className="toolbar">
        {(isAdmin || (process.env.ALLOW_PUBLIC_JSON_IMPORT && loggedIn)) && (
          <div className="import-wrapper">
            <input
              type="file"
              id="wizard-import"
              name="wizard-import"
              accept="application/json"
              className="faux-hide"
              onChange={this.startImportWizard}
            />
            <label className="btn btn-raised btn-primary import" htmlFor="wizard-import">
              <ImportIcon /> File From Import
            </label>
          </div>
        )}
        <div className="filter-wrapper">
          <input
            type="text"
            className="filter"
            placeholder="Filter"
            value={filter}
            onChange={onChange}
            aria-label="Filter forms"
          />
          {filter && (
            <button aria-label="clear filter" className="clear" onClick={this.clearFilter}>
              <CrossIcon />
            </button>
          )}
        </div>
      </div>
    )
  }
}
Toolbar = connect(
  (state) => ({
    isAdmin: state.auth.USER_GROUP === 'ADMIN_WEB' || state.auth.USER_GROUP === 'ADMIN',
    loggedIn: state.auth.loggedIn,
  }),
  { fetchAndPopulateWizard, reconstructWizardWithValues, resetWizardState }
)(Toolbar)

export class DumbCategory extends Component {
  getFilteredForms = () => {
    if (this.props.filter === '') {
      return this.props.wizardsOrder || []
    } else {
      const filter = this.props.filter.toLowerCase()
      return (this.props.wizardsOrder || []).filter((fId) =>
        this.props.wizards[fId]
          ? this.props.wizards[fId].TITLE.toLowerCase().includes(filter)
          : false
      )
    }
  }
  render() {
    const { title, wizards, loadForm, icon = '' } = this.props
    const filteredForms = this.getFilteredForms()
    return (
      filteredForms.length > 0 && (
        <div className="category">
          <div className="title-wrapper">
            <h2 className="title">{title}</h2>
          </div>
          <div className={`form-blocks ${process.env.ID_EXTRA_FORMS_PADDING ? 'form-blocks-idaho' : ''}`}>
            {filteredForms.map((formDefinitionId) => {
              let wizard = wizards[formDefinitionId]
              return (
                wizard && (
                  <ExpandableFormBlock
                    label={wizard.TITLE}
                    onPrimaryButtonClick={loadForm}
                    description={wizard.DESCR}
                    formDefinitionId={wizard.FORM_DEFINITION_ID}
                    actionIcon={<DocumentAddIcon />}
                    icon={icon}
                    key={formDefinitionId}
                  />
                )
              )
            })}
          </div>
          {/* <hr className="divider"/> */}
        </div>
      )
    )
  }
}

export class ExpandableFormBlock extends Component {
  state = {
    expanded: false,
    initialHeight: null,
    closing: false,
  }
  expandCard = () => {
    if (this.props.onStartExpand) {
      this.props.onStartExpand()
    }
    const size = this.block.getSize()
    this.setState({
      expanded: true,
      initialHeight: size.height,
    })
    this.registerEscapeListener()
  }
  collapseCard = (shouldNotReturnFocus) => {
    this.setState({
      expanded: false,
      closing: false,
    })
    this.unregisterEscapeListener()
  }
  startCollapse = () => {
    if (this.props.onStartCollapse) {
      this.props.onStartCollapse()
    }
    this.setState({
      closing: true,
    })
    if (this.card) {
      this.card.getInstance().close()
    }
  }
  registerEscapeListener = () => {
    document.addEventListener('keydown', this.handleKeyDown)
  }
  unregisterEscapeListener = () => {
    document.removeEventListener('keydown', this.handleKeyDown)
  }
  handleKeyDown = (e) => {
    if (e.keyCode === 27) {
      this.startCollapse()
      if (this.wrapper) {
        this.wrapper.focus()
      }
    }
  }
  handleButtonKeyDown = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault()
      if (this.state.expanded) {
        this.startCollapse()
      } else {
        this.expandCard()
      }
    }
  }
  render() {
    const {
      label,
      icon,
      onPrimaryButtonClick,
      formDefinitionId,
      className = '',
      metadata,
      actions,
      collapsedChildren,
      description,
    } = this.props
    return (
      <div
        role="button"
        tabIndex={this.state.expanded ? -1 : 0}
        ref={(ref) => {
          this.wrapper = ref
        }}
        className={`form-block-wrapper custom-focus ${className}`}
        style={{
          zIndex: this.state.expanded && !this.state.closing ? 10 : '',
        }}
        onClick={this.state.expanded ? this.startCollapse : this.expandCard}
        onKeyDown={this.handleButtonKeyDown}
        aria-expanded={this.state.expanded}
      >
        {this.state.expanded && (
          <FormBlockCard
            onCloseAnimationFinished={this.collapseCard}
            ref={(ref) => {
              this.card = ref
            }}
            description={description}
            formDefinitionId={formDefinitionId}
            onPrimaryButtonClick={onPrimaryButtonClick}
            label={label}
            animated
            initialHeight={this.state.initialHeight}
            onRequestClose={this.startCollapse}
            icon={icon}
            metadata={metadata}
            actions={actions}
          />
        )}
        <DummyFormBlock
          ref={(ref) => {
            this.block = ref
          }}
          label={label}
          icon={icon}
        >
          {collapsedChildren}
        </DummyFormBlock>
      </div>
    )
  }
}

export class FormBlockCard extends React.PureComponent {
  state = {
    visible: false,
    targetHeight: this.props.initialHeight + 20,
    closing: false,
  }
  id = shortid.generate()
  componentDidMount = () => {
    this.calculateTargetHeight()
    if (document.activeElement) {
      document.activeElement.blur()
    }
    this.setVisible(true)
    setTimeout(() => {
      if (this.fileOnline) {
        this.fileOnline.focus()
      }
    })
  }
  close = (shouldNotReturnFocus) => {
    this.setState({
      targetHeight: this.props.initialHeight + 20,
      closing: true,
      shouldNotReturnFocus,
    })
  }
  setVisible = (visible) => {
    this.setState({
      visible,
    })
  }
  calculateTargetHeight = () => {
    const card = this.card.getBoundingClientRect()
    this.setState({
      targetHeight: card.height,
    })
  }
  handleClickOutside = () => {
    this.props.onRequestClose()
  }
  onPrimaryButtonClick = (e) => {
    e.stopPropagation()
    this.props.onPrimaryButtonClick(this.props.formDefinitionId)
  }
  render() {
    const { label, icon, animated, metadata, actions, description } = this.props
    return (
      <Transition props={{ height: this.state.targetHeight }} duration={300}>
        {(props) => (
          <div
            ref={(ref) => {
              this.card = ref
            }}
            className={`form-block-card ${
              animated ? (this.state.closing ? 'shadow-out' : 'shadow-in') : ''
            }`}
            style={{
              height: this.state.visible ? props.height : '',
              opacity: this.state.visible ? 1 : 0,
            }}
            role="dialog"
            onKeyDown={(e) => e.preventDefault()}
            onBlur={(e) => {
              setTimeout(() => {
                if (!this.card.contains(document.activeElement)) {
                  this.close(true)
                }
              })
            }}
          >
            {this.state.closing && (
              <RestDetector
                target={this.props.initialHeight + 20}
                current={props.height}
                onRest={() => {
                  this.props.onCloseAnimationFinished(this.state.shouldNotReturnFocus)
                }}
              />
            )}

            <FocusTrap
              focusTrapOptions={{ clickOutsideDeactivates: true }}
              onKeyDown={this.handleKeyDown}
              role="dialog"
            >
              <button
                ref={(ref) => {
                  this.closeBtn = ref
                }}
                className="close-button"
                onClick={this.props.onRequestClose}
                aria-label="Close Modal"
              >
                <span className=" visually-hidden">
                  Close Modal
                </span>
                <span className="icon icon-cross" aria-hidden="true" />
              </button>
              <DummyFormBlock label={label} icon={icon} />
              <p className="description" id={this.id}>
                {description}
              </p>

              {metadata ? metadata : null}

              <div className="actions">
                {actions ? (
                  actions
                ) : (
                  <button
                    className="btn btn-primary btn-text"
                    aria-describedby={this.id}
                    onMouseDown={(e) => e.preventDefault()}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        this.onPrimaryButtonClick(e)
                      }
                    }}
                    onClick={this.onPrimaryButtonClick}
                    ref={(ref) => {
                      this.fileOnline = ref
                    }}
                  >
                    File Online
                  </button>
                )}
              </div>
            </FocusTrap>
          </div>
        )}
      </Transition>
    )
  }
}
FormBlockCard = onClickOutside(FormBlockCard)

class RestDetector extends Component {
  componentDidUpdate = (prevProps) => {
    if (this.props.current === prevProps.target) {
      this.props.onRest()
    }
  }
  render() {
    return null
  }
}

export class DummyFormBlock extends React.Component {
  getSize = () => {
    const wrapper = this.wrapper.getBoundingClientRect()
    return { width: wrapper.width, height: wrapper.height }
  }
  render() {
    const { label, icon, children } = this.props
    return (
      <div
        className="form-block"
        ref={(ref) => {
          this.wrapper = ref
        }}
      >
        <DummyFormIcon icon={icon} />
        <div className='heading'>
          <span className="title">{label}</span>
        </div>
        {children}
      </div>
    )
  }
}

export class DummyFormIcon extends React.PureComponent {
  render() {
    const { style = {}, className = '', icon, innerRef } = this.props
    return (
      <div className={`form-block-icon-container ${className}`} ref={innerRef} style={style}>
        <div className="abbr-wrapper">
          <div className="abbr">{ICONS[icon]}</div>
          <DocumentIcon />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Forms/Forms.js